module.exports = __webpack_public_path__ + "./Jennie_9c08edd9ef5b9037912d416a9e3787ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/Jennie.jpg
// module id = 528
// module chunks = 0